import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { convertToSearchCriteria, getErrorMessageFromBlob, serialize } from 'helpers/api';
import {
  getStoreOrdersStart,
  getStoreOrdersSuccess,
  getStoreOrdersFailed,
  resendOrderEmailStart,
  resendOrderEmailSuccess,
  resendOrderEmailFailed,
  updateStoreOrderStart,
  updateStoreOrderSuccess,
  updateStoreOrderFailed,
  saveStoreOrderCommentStart,
  saveStoreOrderCommentSuccess,
  saveStoreOrderCommentFailed,
  holdOrdersStart,
  holdOrdersSuccess,
  holdOrdersFailed,
  unholdOrdersStart,
  unholdOrdersSuccess,
  unholdOrdersFailed,
  updateMultipleOrdersPostedStatusStart,
  updateMultipleOrdersPostedStatusSuccess,
  updateMultipleOrdersPostedStatusFailed,
  generateOrdersInvoicePdfStart,
  generateOrdersInvoicePdfSuccess,
  generateOrdersInvoicePdfFailed,
  getStoreOrderItemsDetailsStart,
  getStoreOrderItemsDetailsSuccess,
  getStoreOrderItemsDetailsFailed,
  getInvoiceOrderDataStart,
  getInvoiceOrderDataSuccess,
  getInvoiceOrderDataFailed,
  getOrderProductsBySkusStart,
  getOrderProductsBySkusSuccess,
  getOrderProductsBySkusFailed,
  refundOrderStart,
  refundOrderSuccess,
  refundOrderFailed,
  shipOrderStart,
  shipOrderSuccess,
  shipOrderFailed,
  getNextechDuplicatedCustomersStart,
  getNextechDuplicatedCustomersSuccess,
  getNextechDuplicatedCustomersFailed,
  getModmedDuplicatedCustomersStart,
  getModmedDuplicatedCustomersSuccess,
  getModmedDuplicatedCustomersFailed,
  updateNextechStatusStart,
  updateNextechStatusSuccess,
  updateNextechStatusFailed,
  getInvoiceCommentsStart,
  getInvoiceCommentsSuccess,
  getInvoiceCommentsFailed,
  getShippingCommentsStart,
  getShippingCommentsSuccess,
  getShippingCommentsFailed,
  getCreditMemoCommentsStart,
  getCreditMemoCommentsSuccess,
  getCreditMemoCommentsFailed,
  getOrderShipmentsStart,
  getOrderShipmentsSuccess,
  getOrderShipmentsFailed,
  getPaymentMethodNameStart,
  getPaymentMethodNameSuccess,
  getPaymentMethodNameFailed
} from 'redux/actions/store_orders';


export const getStoreOrdersApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getStoreOrdersStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/order?${params}`);
    dispatch(getStoreOrdersSuccess(data));
  } catch (e) {
    dispatch(getStoreOrdersFailed(e));
  }
};

export const resendOrderEmailApi = async ({dispatch, orderId}) => {
  try {
    dispatch(resendOrderEmailStart());
    await api.post(`${shopManagerApi}/store/order/${orderId}/email`);
    dispatch(resendOrderEmailSuccess());
  } catch (e) {
    dispatch(resendOrderEmailFailed(e));
  }
};

export const updateStoreOrderApi = async ({
  dispatch,
  order
}) => {
  try {
    dispatch(updateStoreOrderStart());
    const { data } = await api.put(`${shopManagerApi}/store/order`, order);
    dispatch(updateStoreOrderSuccess(data));
  } catch (e) {
    dispatch(updateStoreOrderFailed(e));
  }
};

export const saveStoreOrderCommentApi = async ({
  dispatch,
  orderId,
  comment
}) => {
  try {
    dispatch(saveStoreOrderCommentStart());
    await api.post(`${shopManagerApi}/store/order/${orderId}/comments`, comment);
    dispatch(saveStoreOrderCommentSuccess(orderId, comment));
  } catch (e) {
    dispatch(saveStoreOrderCommentFailed(e));
  }
};

export const holdOrdersApi = async ({ dispatch, orderIds = [] }) => {
  try {
    dispatch(holdOrdersStart());
    const promises = orderIds.map((orderId) => api.post(`${shopManagerApi}/store/order/${orderId}/hold`));
    await Promise.all(promises);
    dispatch(holdOrdersSuccess(orderIds));
  } catch (e) {
    dispatch(holdOrdersFailed(e));
  }
};

export const unholdOrdersApi = async ({ dispatch, orderIds = [] }) => {
  try {
    dispatch(unholdOrdersStart());
    const promises = orderIds.map((orderId) => api.post(`${shopManagerApi}/store/order/${orderId}/unhold`));
    await Promise.all(promises);
    dispatch(unholdOrdersSuccess(orderIds));
  } catch (e) {
    dispatch(unholdOrdersFailed(e));
  }
};

export const updateMultipleOrdersPostedStatusApi = async ({ dispatch, orders }) => {
  try {
    dispatch(updateMultipleOrdersPostedStatusStart());
    const promises = orders.map((orderData) => api.put(`${shopManagerApi}/store/order`, orderData));
    await Promise.all(promises);
    dispatch(updateMultipleOrdersPostedStatusSuccess(orders));
  } catch (e) {
    dispatch(updateMultipleOrdersPostedStatusFailed(e));
  }
};

export const generateOrdersInvoicePdfApi = async ({ dispatch, orderIds }) => {
  try {
    dispatch(generateOrdersInvoicePdfStart());
    const { data } = await api.post(`${shopManagerApi}/store/order/invoice-pdf`, { orderIds }, { responseType: 'blob' });
    const blob = new Blob([data], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');

    dispatch(generateOrdersInvoicePdfSuccess(data));
  } catch (error) {
    let errorMessage = 'An unknown error occurred';

    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      errorMessage = await getErrorMessageFromBlob(error.response.data) || errorMessage;
    }

    dispatch(generateOrdersInvoicePdfFailed(new Error(errorMessage)));
  }
};

export const getStoreOrderItemsDetailsApi = async ({
  dispatch,
  entityId
}) => {
  try {
    dispatch(getStoreOrderItemsDetailsStart());
    const {data} = await api.get(`${shopManagerApi}/store/order/${entityId}/items/options`);
    dispatch(getStoreOrderItemsDetailsSuccess(data, entityId));
  } catch (e) {
    dispatch(getStoreOrderItemsDetailsFailed(e));
  }
};

export const getInvoiceOrderDataApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getInvoiceOrderDataStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const {data} = await api.get(`${shopManagerApi}/store/order/invoice?${params}`);
    dispatch(getInvoiceOrderDataSuccess(data));
    return true;
  } catch (e) {
    dispatch(getInvoiceOrderDataFailed(e));
    return false;
  }
};

export const getOrderProductsBySkusApi = async ({dispatch, skus }) => {
  try {
    dispatch(getOrderProductsBySkusStart());
    const params: { limit: number, skus?: [] } = { limit: 1000 };
    skus && (params.skus = skus);
    const { data } = await api.get(`${shopManagerApi}/store/products${serialize(params)}`);
    dispatch(getOrderProductsBySkusSuccess(data));
    return true;
  } catch (e) {
    dispatch(getOrderProductsBySkusFailed(e));
    return false;
  }
};

export const refundOrderApi = async ({
  dispatch,
  refundData
}) => {
  try {
    dispatch(refundOrderStart());
    await api.post(`${shopManagerApi}/store/order/refund/creditmemo`, refundData);
    dispatch(refundOrderSuccess());
    return true;
  } catch (e) {
    dispatch(refundOrderFailed(e));
    return false;
  }
};


export const shipOrderApi = async ({
  dispatch,
  entityId,
  shipData,
  isOrderComplete
}) => {
  try {
    dispatch(shipOrderStart());
    await api.post(`${shopManagerApi}/store/order/${entityId}/shipment`, shipData);
    dispatch(shipOrderSuccess(entityId, isOrderComplete, shipData));
    return true;
  } catch (e) {
    dispatch(shipOrderFailed(e));
    return false;
  }
};

export const getNextechDuplicatedCustomersApi = async ({ dispatch, orderId }) => {
  try {
    dispatch(getNextechDuplicatedCustomersStart());
    const { data } = await api.get(`${shopManagerApi}/store/nextech-integration/duplicated-customers/${orderId}`);
    dispatch(getNextechDuplicatedCustomersSuccess(data));
  } catch (e) {
    dispatch(getNextechDuplicatedCustomersFailed(e));
  }
};

export const getModmedDuplicatedCustomersApi = async ({ dispatch, orderId }) => {
  try {
    dispatch(getModmedDuplicatedCustomersStart());
    const { data } = await api.get(`${shopManagerApi}/store/modmed-integration/duplicated-customers/${orderId}`);
    dispatch(getModmedDuplicatedCustomersSuccess(data));
  } catch (e) {
    dispatch(getModmedDuplicatedCustomersFailed(e));
  }
};

export const updateNextechStatusApi = async ({dispatch, customerId, customerData}) => {
  try {
    dispatch(updateNextechStatusStart());
    const {data} = await api.put(`${shopManagerApi}/store/customer/${customerId}`, customerData);
    dispatch(updateNextechStatusSuccess(data));
    return true;
  } catch (e) {
    dispatch(updateNextechStatusFailed(e));
    return false;
  }
};

export const getInvoiceCommentsApi = async ({dispatch, orderId}) => {
  try {
    dispatch(getInvoiceCommentsStart());
    const {data} = await api.get(`${shopManagerApi}/store/order/${orderId}/invoice/comments`);
    dispatch(getInvoiceCommentsSuccess(data));
  } catch (e) {
    dispatch(getInvoiceCommentsFailed(e));
  }
};

export const getShippingCommentsApi = async ({dispatch, orderId}) => {
  try {
    dispatch(getShippingCommentsStart());
    const {data} = await api.get(`${shopManagerApi}/store/order/${orderId}/shipment/comments`);
    dispatch(getShippingCommentsSuccess(data));
  } catch (e) {
    dispatch(getShippingCommentsFailed(e));
  }
};

export const getCreditMemoCommentsApi = async ({dispatch, orderId}) => {
  try {
    dispatch(getCreditMemoCommentsStart());
    const {data} = await api.get(`${shopManagerApi}/store/order/${orderId}/creditmemo/comments`);
    dispatch(getCreditMemoCommentsSuccess(data));
  } catch (e) {
    dispatch(getCreditMemoCommentsFailed(e));
  }
};

export const getOrderShipmentsApi = async ({dispatch, orderId}) => {
  try {
    dispatch(getOrderShipmentsStart());
    const {data} = await api.get(`${shopManagerApi}/store/order/${orderId}/shipments`);
    dispatch(getOrderShipmentsSuccess(data, orderId));
  } catch (e) {
    dispatch(getOrderShipmentsFailed(e));
  }
};

export const getPaymentMethodNameApi = async ({dispatch, method}) => {
  try {
    dispatch(getPaymentMethodNameStart());
    const {data = []} = await api.get(`${shopManagerApi}/store/order/payment-method-name?method=${method}`);
    const name = data[0]?.value;
    dispatch(getPaymentMethodNameSuccess({method, name}));
  } catch (e) {
    dispatch(getPaymentMethodNameFailed(e));
  }
};
